<template>
  <div class="container_gall" @click.stop="handleGallaryClick">
    <div class="wrapper">
      <swiper :options="swiperOptions" ref="mySwiper">
        <swiper-slide v-for="(item, index) in imgs" :key="index">
          <img class="gallary-img" :src="item" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonGallary',
  props: {
    imgs: {
      type: Array,
      default() {
        return []
      }
    },
    curIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      swiperOptions: {
        pagination: '.swiper-pagination',
        paginationType: 'fraction',
        observeParents: true,
        observer: true,
        zoom: false,
        zoomMax: 3
      }
    }
  },
  created() {},
  watch: {
    curIndex(val) {
      this.$refs.mySwiper.swiper.slideTo(val, 1000, true)
    }
  },
  methods: {
    handleGallaryClick() {
      // let swiper = this.$refs.mySwiper.swiper;
      // let i = swiper.activeIndex;
      // this.curIndex = i
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/common.less';

/deep/ .swiper-container {
  overflow: inherit;
}
.container_gall {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #000;
  .wrapper {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .swiper-container {
      width: 100%;
      height: 100%;
      margin: 0 auto;
    }
    /deep/ .swiper-wrapper {
      width: 100% !important;
      height: 100% !important;
    }
    .swiper-slide {
      width: 100% !important;
      height: 100% !important;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    .gallary-img {
      height: 100%;
      object-fit: contain;
      width: 100%;
    }
    .swiper-pagination {
      color: #fff;
      bottom: 100px;
      position: fixed;
      left: 0;
      right: 0;
      width: 100%;
      .fontSize(18px);
      text-align: center;
    }
  }
}
</style>
